import { router } from '@inertiajs/vue3';
import { onUnmounted, ref } from 'vue'; // const openUnsavedChangesModal = (event: Object) => {
import { eventBus, events } from '../eventBus';

type Config = {
    hasChanges: () => boolean;
    handleSubmit: (event) => Promise<boolean>;
};

export const useUnsavedChangesWarning = (config: Config) => {
    const forceLeavePage = ref(false);

    const openUnsavedChangesModal = (event: Object) => {
        eventBus.$emit(events.openUnsavedChangesModal, {
            onSaveAndExitPressed: (closeModal, isProcessing) => {
                isProcessing.value = true;

                config.handleSubmit({ redirectUrl: event.detail.visit.url }).finally(() => {
                    isProcessing.value = false;
                    closeModal();
                });
            },
            onExitWithoutSavingPressed: (closeModal) => {
                forceLeavePage.value = true;
                router.visit(event.detail.visit.url);
            },
        });
    };

    const shouldShowUnsavedChangesModal = (event: Object) => {
        // Partial reloads (only: [...]) refetch props on the current page — they don't
        // navigate away, so they must not trigger the "unsaved changes" prompt.
        const isPartialReload = event.detail.visit.only.length > 0;

        return (
            config.hasChanges() &&
            event.detail.visit.method === 'get' &&
            !isPartialReload &&
            !forceLeavePage.value &&
            !event.detail.visit.url.searchParams.has('force')
        );
    };

    let removeEventListener = router.on('before', (event) => {
        if (shouldShowUnsavedChangesModal(event)) {
            openUnsavedChangesModal(event);
            return false;
        }

        return true;
    });

    onUnmounted(() => {
        removeEventListener && removeEventListener();
    });
};
